import React, { useState } from 'react';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import { updateProfile } from '../../../../../../API';
import { config } from '../../../../../../config';

import './ChangeEmailModal.less';

const { REACT_APP_BUILD_ENV } = config;

export const ChangeEmailModal = (props) => {
  const { onCancel, onSubmit, theme } = props;
  const [newEmail, setNewEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const currentUser = JSON.parse(localStorage.getItem('current_user'));
  const { email, first_name: firstName, last_name: lastName, phone_number: phoneNumber } = currentUser;

  const submitEmailChange = async () => {
    const response = await updateProfile(REACT_APP_BUILD_ENV, newEmail, firstName, lastName, phoneNumber);

    if (response === 200) {
      setErrorMessage('');
      onSubmit();
    } else {
      setErrorMessage(`${response}`);
    }
  };

  return (
    <Modal
      className={`alerts-preferences-change-email-modal alerts-preferences-change-email-modal-${theme}`}
      centered
      open
      keyboard
      title="Change E-mail"
      footer={null}
      onCancel={onCancel}
    >
      <div className="alerts-preferences-change-email-modal__current-email-container">
        <span className="alerts-preferences-change-email-modal__container-title">Current e-mail:</span>
        <strong className="alerts-preferences-change-email-modal__current-email">{email}</strong>
      </div>
      <div className="alerts-preferences-change-email-modal__input-container">
        <span className="alerts-preferences-change-email-modal__container-title">New e-mail:</span>
        <Input
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          size="large"
          className="alerts-preferences-change-email-modal__input"
        />
      </div>
      <Button size="large" className="alerts-preferences-change-email-modal__button" onClick={submitEmailChange}>
        <span className="alerts-preferences-change-email-modal__button-text">Apply Change</span>
      </Button>
      {errorMessage && <div className="alerts-preferences-change-email-modal__error">{errorMessage}</div>}
    </Modal>
  );
};
